"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-SpanLinkModal',
    leftPanel: 'c-SpanLinkModal__panelLeft',
    rightPanel: 'c-SpanLinkModal__panelRight',
    panelTitle: 'c-SpanLinkModal__panelTitle',
    panelFooter: 'c-SpanLinkModal__panelFooter',
    spanList: 'c-SpanLinkModal__spanList',
    spanItem: 'c-SpanLinkModal__spanItem',
    createNewOption: 'c-SpanLinkModal__createNew',
    previewContainer: 'c-SpanLinkModal__preview',
    previewEmpty: 'c-SpanLinkModal__previewEmpty',
    emptyMessage: 'c-SpanLinkModal__emptyMessage',
};
// Base style for selectable list items with hidden radio input pattern
const selectableItemBase = {
    position: 'relative',
    display: 'flex',
    '&:hover': {
        'background-color': theme_1.DefaultTheme.font.color.divider,
    },
    '& input': {
        appearance: 'none',
        '&::-ms-check': {
            display: 'none',
        },
        position: 'absolute',
    },
    '& input + label': {
        width: '100%',
        'border-left': `${theme_1.DefaultTheme.space(1.5)} solid transparent`,
        padding: `${theme_1.DefaultTheme.space(1)} ${theme_1.DefaultTheme.space(2)}`,
        cursor: 'pointer',
    },
    '& input:focus + label': {
        outline: `1px solid ${theme_1.DefaultTheme.color.accent}`,
        'margin-right': '1px',
    },
    '& input:checked + label': {
        'background-color': theme_1.DefaultTheme.background.offWhite,
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
    },
};
exports.Style = {
    [exports.CSS.container]: {
        display: 'flex',
        width: '800px',
        height: '550px',
        'min-height': 0,
    },
    [exports.CSS.leftPanel]: {
        flex: 1,
        'border-right': `1px solid ${theme_1.DefaultTheme.font.color.divider}`,
        'overflow-y': 'auto',
        display: 'flex',
        'flex-direction': 'column',
    },
    [exports.CSS.rightPanel]: {
        flex: 1.5,
        'overflow-y': 'auto',
    },
    [exports.CSS.panelTitle]: {
        'font-family': theme_1.DefaultTheme.font.familyCondensed,
        'font-weight': theme_1.DefaultTheme.font.weight.bold,
        'padding-bottom': theme_1.DefaultTheme.space(2),
    },
    [exports.CSS.panelFooter]: {
        'padding-top': theme_1.DefaultTheme.space(2),
    },
    [exports.CSS.spanList]: {
        flex: 1,
        'overflow-y': 'auto',
        'background-color': theme_1.DefaultTheme.background.grey,
    },
    [exports.CSS.spanItem]: selectableItemBase,
    [exports.CSS.createNewOption]: Object.assign(Object.assign({}, selectableItemBase), { marginTop: theme_1.DefaultTheme.space(2), '& input + label': Object.assign(Object.assign({}, selectableItemBase['& input + label']), { 'font-weight': theme_1.DefaultTheme.font.weight.bold }), '& input:checked + label': Object.assign(Object.assign({}, selectableItemBase['& input:checked + label']), { 'border-left': `${theme_1.DefaultTheme.space(1.5)} solid ${theme_1.DefaultTheme.color.accent}` }) }),
    [exports.CSS.previewEmpty]: {
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        height: '100%',
        color: theme_1.DefaultTheme.font.color.supporting,
        'font-style': 'italic',
    },
    [exports.CSS.emptyMessage]: {
        padding: theme_1.DefaultTheme.space(4),
        color: theme_1.DefaultTheme.font.color.supporting,
        'text-align': 'center',
    },
};
//# sourceMappingURL=span.link.modal.style.js.map